import API from "@aws-amplify/api";

// Fetches the clients from the cmp-v2-clients dynamo table (via the /clients
// endpoint on the prodcmpapp API, see amplify/.../prodcmpclients/src/app.js)
// and builds a { clientId: name } lookup. This replaces the previously
// hardcoded client-id -> name maps in FileUpload.jsx and AddRule.jsx.
//
// The map is keyed by BOTH the top-level client `id` and each concept's
// settings.cmp.clientId so it resolves whichever UUID ends up in
// localStorage.clientId.

const apiName = process.env.REACT_APP_AMPLIFY_API;
const clientsPath = "/clients";

// Cache the in-flight/resolved promise so repeated calls (and both views)
// share a single scan instead of hitting the API every mount.
let cachedMapPromise = null;

export async function getClientIdNameMap(forceRefresh = false) {
  if (!cachedMapPromise || forceRefresh) {
    cachedMapPromise = API.get(apiName, clientsPath)
      .then((clients) => {
        const map = {};
        (clients || []).forEach((client) => {
          if (!client || !client.name) return;
          if (client.id) {
            map[client.id] = client.name;
          }
          (client.concepts || []).forEach((concept) => {
            const cmpClientId =
              concept &&
              concept.settings &&
              concept.settings.cmp &&
              concept.settings.cmp.clientId;
            if (cmpClientId) {
              map[cmpClientId] = client.name;
            }
          });
        });
        return map;
      })
      .catch((error) => {
        console.log("Error fetching client id/name map", error);
        // Allow a retry on the next call rather than caching the failure.
        cachedMapPromise = null;
        return {};
      });
  }
  return cachedMapPromise;
}

export default getClientIdNameMap;



// WEBPACK FOOTER //
// ./src/util/clients/getClientIdNameMap.js